import { Flow_0_0_2 } from '@flexus/core';

export const PGG_62: Flow_0_0_2 = {
	id: '62',
	name: 'paused_needs_appointment',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to change appointment'
		}
	},
	startNode: '',
	nodes: {}
};
